module.exports = __webpack_public_path__ + "img/steps.5e113e71.svg";